<template>
  <AppDialog v-model="dialogModel" width="1000px">
    <template #activator="{on,attrs}">
      <button
        v-on="on"
        v-bind="attrs"
        class="button-add-card"
      >
        <div class="button-add-card__icon">
          <svg
            width="23"
            height="22"
            viewBox="0 0 23 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M10 0H13V22H10V0Z" fill="#C4C4C4" />
            <path d="M22.5 9.5L22.5 12.5L0.5 12.5L0.5 9.5L22.5 9.5Z" fill="#C4C4C4" />
          </svg>
        </div>
        <div class="button-add-card__name">
          {{ $t('add') }}
        </div>
      </button>
    </template>
    <VCard>
      <VCardTitle class="mb-4">
        {{ $t('add') }}
      </VCardTitle>
      <VCardText>
        <PaymentMethodCardStripeAdd
          v-if="account.driver === paymentDrivers.STRIPE"
          @created="onCreated"
          :trial-page="trialPage"
        >
          <template v-if="needRenew">
            <VCheckbox
              v-model="needRenewCheckbox"
              :label="$t('renewSubscriptionAfterCreating')"
              style="font-size: 0.75rem"
              class="cabinet-input"
            />
          </template>
        </PaymentMethodCardStripeAdd>
        <PaymentMethodCardAlfabankAdd v-if="account.driver === paymentDrivers.ALFABANK" />
      </VCardText>
    </VCard>
  </AppDialog>
</template>
<script>
import AppDialog from '@/components/AppDialog';
import PaymentMethodCardStripeAdd from '@/components/Payment/Methods/PaymentMethodCardStripeAdd';
import useDialog from '@/compositions/useDialog';
import useSubscription from '@/compositions/accounting/useSubscription';
import { paymentDrivers, paymentTabs, settingsTabs } from '@/enums';
import { computed, ref } from '@vue/composition-api';
import useAccount from '@/compositions/accounting/useAccount';
import PaymentMethodCardAlfabankAdd
  from '@/components/Payment/Methods/PaymentMethodCardAlfabankAdd';

export default {
  name: 'PaymentMethodDialogAdd',
  components: { PaymentMethodCardAlfabankAdd, PaymentMethodCardStripeAdd, AppDialog },
  props: {
    trialPage: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup(_, { emit, root: { $route, $router } }) {
    const { dialogModel } = useDialog();
    const { account } = useAccount();
    const { renewActiveSubscription } = useSubscription();
    const needRenewCheckbox = ref(true);

    const needRenew = computed(() => $route.query.renew === 'true');

    async function onCreated() {
      emit('created');
      dialogModel.value = false;
      if (!(needRenew.value && needRenewCheckbox.value)) {
        return;
      }
      await renewActiveSubscription();
      $router.push({
        name: 'settings',
        params: {
          type: settingsTabs.PAYMENT,
          addType: paymentTabs.PLAN,
        },
      });
    }

    return {
      dialogModel,
      onCreated,
      needRenew,
      needRenewCheckbox,
      account,
      paymentDrivers,
    };
  },
};
</script>

<style lang="scss" scoped>
.button-add-card {
  width: 100%;
  display: flex;
  align-items: center;
  padding: 1.5rem;
  border: 1px dashed #E0E0E0;
  border-radius: 0.5rem;
  margin-bottom: 2rem;
  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 4.0625rem;
    height: 3.25rem;
    background: rgba(238, 238, 238, 0.4);
    border: 1px solid #EEEEEE;
    border-radius: 0.5rem;
    margin-right: 1.625rem;
  }
  &__name{
    display: flex;
    font-size: 1.0625rem;
    font-weight: 500;
    line-height: 1.53;
    color: #091A35;
  }
}
@media #{map-get($display-breakpoints, 'md-and-down')} {
  .button-add-card {
    padding: 0.9375rem;
    height: 4.875rem;
    &__icon {
      width: 3.5rem;
      height: 2.8rem;
      margin-right: 1.25rem;
      svg {
        width: 1rem;
      }
    }
    &__name {
      font-size: 0.9375rem;
    }
  }
}
@media #{map-get($display-breakpoints, 'xs-only')} {
.button-add-card {
  padding: 0.9375rem 0.75rem;
  height: 5.25rem;
  margin-bottom: 2rem;
  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2.5rem;
    height: 2rem;
    margin-right: 1rem;
    svg {
      width: 1rem;
    }
  }
  &__name {
    font-size: 0.8125rem;
  }
}
}
</style>

<i18n lang="yml" locale="ru">
add: Добавить карту
renewSubscriptionAfterCreating: Оплатить продление подписки после добавления способа оплаты
</i18n>
<i18n lang="yml" locale="en">
add: Add сard
renewSubscriptionAfterCreating: Renew my subscription once I have added a payment method
</i18n>
